import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { ApiService } from '../../services/jrni/api.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { LoginService } from '../../services/jrni/login.service';
import { MemberService } from '../../services/jrni/member.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  selectedDepartment: any;
  pageTitle: any;
  locationPageText: any;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  showLogin = true;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  submitted: boolean = false;
  access_page_sub_title: any;
  hide: boolean = true;

  passwordResetForm: FormGroup;
  shouldShowPasswordReset: boolean = false;
  resetSubmitted: boolean = false;
  resetSuccess: boolean = false;
  resetPath: string = '';
  resetError: boolean = true;
  loginError: boolean = false;
  loginErrorMessage: string = '';

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private datastoreService: DatastoreService,
    private memberService: MemberService,
    private apiService: ApiService,
    private loginService: LoginService
  ) { }

  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
    password: new FormControl('', Validators.required)
  });

  resetPasswordForm: FormGroup = new FormGroup({
    resetemail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
  });

  // Getter for easy access to form fields
  get form() { return this.loginForm.controls; }
  get resetForm() { return this.passwordResetForm.controls; }

  togglePasswordVisible() {
    this.hide = !this.hide;
  }

  routerGoBack() {
    this.router.navigate(['/departments']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  ngOnInit() {
    let staging = ""
    if (window.location.href.includes("staging") || window.location.href.includes("localhost")) {
      staging = "staging"
    }
    this.resetPath = `/?client=eastsussex&environment=hwrc${staging}#/update-password`;
    this.scrollToTop();
    this.spinner.show();
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    // this.departmentService.get().then(selectedDepartment => {
    //   if (selectedDepartment === undefined) {
    //     this.restartJourney();
    //   } else {
    //     this.selectedDepartment = selectedDepartment;

    this.memberService.getMember().then(async member => {
      if (member) {
        this.router.navigate(['/departments']);
        this.spinner.hide();
      } else {
        sessionStorage.removeItem("auth_token");
        sessionStorage.removeItem("login");
        // remove the value from localStorage
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_token");
      }
      this.datastoreService.parentDepartment = await this.departmentService.getParentDepartment();
      this.departmentService.set(this.datastoreService.parentDepartment);
      this.selectedDepartment = this.datastoreService.parentDepartment;

      // Get the configurable data
      if (this.datastoreService.parentDepartment.hasOwnProperty('extra')) {
        // Set the title on the login page to the title from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('access_page_title') ? this.pageTitle = this.datastoreService.parentDepartment.extra.access_page_title : this.pageTitle = "Location title not set";
        // Set the extra text on the page to the text taken from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('access_page_sub_title') ? this.access_page_sub_title = this.datastoreService.parentDepartment.extra.access_page_sub_title : null;
      }
      this.spinner.hide();
    })
    //   }
    // }, err => {
    //   console.log(err);
    //   this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
    //   this.spinner.hide();
    // });
  }


  showLoginToggle() {
    this.showLogin = true
  }

  register() {
    this.router.navigate(['/register']);
  }

  continueAsGuest() {
    sessionStorage.removeItem("auth_token");
    sessionStorage.removeItem("login");
    // remove the value from localStorage
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_token");
    this.continue()
  }

  continue() {


    this.router.navigate(['/departments']);
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }


  onSubmit() {
    this.submitted = true;
    // stop here if the login form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.loginService.loginMember(this.selectedDepartment, this.loginForm.value).then(async res => {
        await this.memberService.setMember(res);
        this.continue()
      })
        .catch((error: HttpErrorResponse) => {
          console.log(error)
          if (error || error['response'] && error['response'].status === 401) {
            this.scrollToTop()
            this.alertService.error(this.translateService.instant('LOGIN.EMAIL_NOT_RECOGNISED'))
          }
        });
    }
  }


  async sendReset() {
    this.resetSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      let parentDepartment = await this.departmentService.getParentDepartment();

      this.apiService.passwordReset(this.resetPasswordForm.value.resetemail, parentDepartment.id).then((res) => {
        this.resetSuccess = true;
      })

    }
  }

  sendToReset() {
    let staging = ""
    if (window.location.href.includes("staging") || window.location.href.includes("localhost")) {
      staging = "staging"
    }
    const url = `https://customer.jrni.com/?client=eastsussex&environment=hwrc${staging}`
    window.location.href = url
  }

}
